<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData" :custom-create-actions="[listBancos, ListMacroFuente]"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedCuentaBancaria" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-selected-data="customUpdateSelectedData"
                    :custom-update-actions="[listBancos, ListMacroFuente]" :custom-update-collection-data="customUpdateCollectionData"
                    @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedCuentaBancaria"
                           :load-data="loadDataCuentaBancaria" :entity="entity" :auth-token="authToken"
                           :list-api="listApi" :queries="queries" :custom-update-load-data="customUpdateLoadData"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataCuentaBancaria"
                  :view="view"
                  :selected-data="selectedCuentaBancaria"
                  :collection-bancos="collectionBancos"
                  :collection-macro-fuentes="collectionMacroFuentes"
                  :custom-update-value-data="customUpdateValueData" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import {firstLetterCapitalize, copiaProfunda} from "@/common/constants";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import CuentasBancariasCrearActualizarComponent
  from "@/components/parametros/components/CuentasBancariasCrearActualizarComponent";
import {listCollectionData, useLayoutMain} from "@/layouts/main";

export default {
  name: 'CuentasBancariasCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    CuentasBancariasCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Cuentas bancarias',
      entity: {gender: 'f', value: 'cuenta bancaria'},
      childFormComponent: 'CuentasBancariasCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'banco.nombre_banco': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre del banco'
        },
        'cuenta_bancaria': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Cuenta bancaria'
        },
        'nombre_cuenta': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre cuenta'
        },
        'tipo_cuenta': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Tipo de cuenta'
        },
        'cuentasFuentesMacro': {
          customCriterion: 'cuentasFuentesMacro.macroFuente.nombre',
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fuente Macro'
        },
        'manejo_cuenta': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Condiciones de manejo'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionBancos = ref([]);
    const collectionMacroFuentes = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedCuentaBancaria = ref({
      id: '',
      banco_id: '',
      id_macro_fuente: '',
      cuenta_bancaria: '',
      nombre_cuenta: '',
      tipo_cuenta: '',
      manejo_cuenta: '',
      estado: '',
      cuentasFuentesMacro:'',
    });
    const loadDataCuentaBancaria = ref({
      banco_id: '',
      cuenta_bancaria: '',
      id_macro_fuente: '',
      nombre_cuenta: '',
      tipo_cuenta: '',
      manejo_cuenta: '',
      cuentasFuentesMacro: '',
      checked: false,
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_CUENTABANCARIA_CREATE,
      list: process.env.VUE_APP_NEST_CUENTABANCARIA_FINDALL,
      update: process.env.VUE_APP_NEST_CUENTABANCARIA_UPDATE,
      updateState: process.env.VUE_APP_NEST_CUENTABANCARIA_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      return value;
    };
    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedCuentaBancaria.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedCuentaBancaria.value = updatedSelectedData;
    }
    const customUpdateLoadData = () => {
      for (const key in loadDataCuentaBancaria.value) {
        let value = loadDataCuentaBancaria.value[key];
        value = customUpdateValueData(key, value);
      }
    };
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionData.value);
      for (const copyData of copyCollectionData) {
        copyData['tipo_cuenta'] = firstLetterCapitalize(copyData['tipo_cuenta']);
      }
      return copyCollectionData;
    };
    const listBancos = async () => await listCollectionData(process.env.VUE_APP_NEST_BANCO_FINDALL, {'collectionBancos': collectionBancos}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    const ListMacroFuente = async () => await listCollectionData(process.env.VUE_APP_NEST_FUENTEMACRO_FINDALL,{'collectionMacroFuentes': collectionMacroFuentes},authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedCuentaBancaria, loadDataCuentaBancaria, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedCuentaBancaria,
      loadDataCuentaBancaria,
      listApi,
      paginate,
      queries,
      collectionBancos,
      collectionMacroFuentes,
      setupUpdateValues,
      cleanLoadSelectedData,
      listBancos,
      ListMacroFuente,
      customUpdateSelectedData,
      customUpdateCollectionData,
      customUpdateLoadData,
      customUpdateValueData
    };
  }
}
</script>
